import React, { useEffect, useState } from 'react'
import { Modal, Checkbox, Select, Button, List, message, Spin, Divider } from 'antd'
import debounce from 'lodash/debounce'
import PosSrc from '../../PosSrc'

const { Option } = Select

function trunc(x) {
  const n = Number(x) || 0
  return n.toFixed(2)
}

function EditComboModal(props) {
  const { visible, row, comboDefinition, storeId, turnId, symbol } = props
  const [keptIds, setKeptIds] = useState([])
  const [extras, setExtras] = useState([])
  const [searchData, setSearchData] = useState([])
  const [searching, setSearching] = useState(false)

  const defaultPresentations = comboDefinition?.presentations || []

  useEffect(() => {
    if (!visible) return

    setKeptIds(row?.kept_presentation_ids?.length ? row.kept_presentation_ids : defaultPresentations.map(p => p.id))
    setExtras(row?.combo_extras ? row.combo_extras.map(e => ({ ...e })) : [])
    setSearchData([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, row])

  const toggleKept = (presentationId, checked) => {
    setKeptIds(prev => (checked ? [...prev, presentationId] : prev.filter(id => id !== presentationId)))
  }

  const searchExtras = debounce(value => {
    if (value.length < 3) {
      setSearchData([])
      return
    }
    setSearching(true)
    PosSrc.searchPresentations(storeId, turnId, value, true, 'desc')
      .then(res => {
        const data = (res?.data || []).filter(p => p.type === 'PRESENTATION')
        setSearchData(data)
        setSearching(false)
      })
      .catch(() => setSearching(false))
  }, 600)

  const addExtra = presentationId => {
    const presentation = searchData.find(p => p.id === presentationId)
    if (!presentation) return

    setExtras(prev => {
      const existing = prev.find(e => e.presentation_id === presentation.id)
      if (existing) {
        return prev.map(e => (e.presentation_id === presentation.id ? { ...e, quantity: e.quantity + 1 } : e))
      }
      return [...prev, { presentation_id: presentation.id, description: presentation.description, unit_price: presentation.price, quantity: 1 }]
    })
  }

  const changeExtraQuantity = (presentationId, quantity) => {
    const parsed = Number(quantity)
    setExtras(prev => prev.map(e => (e.presentation_id === presentationId ? { ...e, quantity: parsed > 0 ? parsed : 1 } : e)))
  }

  const removeExtra = presentationId => {
    setExtras(prev => prev.filter(e => e.presentation_id !== presentationId))
  }

  const extrasTotal = extras.reduce((acc, e) => acc + e.quantity * e.unit_price, 0)
  const comboPrice = Number(row?.price) || 0
  const comboQuantity = Number(row?.units) || 0
  const total = comboPrice * comboQuantity + extrasTotal

  const onConfirm = () => {
    if (keptIds.length === 0) {
      message.warning('El combo debe mantener al menos una presentación')
      return
    }

    props.onConfirm({
      kept_presentation_ids: keptIds.length === defaultPresentations.length ? null : keptIds,
      combo_extras: extras,
      total,
    })
  }

  return (
    <Modal
      title={`Ver Combo — ${comboDefinition?.description || ''}`}
      visible={visible}
      onCancel={props.onClose}
      footer={[
        <Button key="cancel" onClick={props.onClose}>Cancelar</Button>,
        <Button key="confirm" type="primary" className="title-tendero new-button" onClick={onConfirm}>Confirmar</Button>,
      ]}
      width={520}
    >
      <div className="title-space-field">Presentaciones del combo</div>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 8 }}>
        Quitar una no baja el precio fijo del combo ({symbol} {trunc(comboPrice)}).
      </div>
      <List
        size="small"
        dataSource={defaultPresentations}
        renderItem={presentation => (
          <List.Item>
            <Checkbox
              checked={keptIds.includes(presentation.id)}
              onChange={e => toggleKept(presentation.id, e.target.checked)}
            >
              {presentation.description}
            </Checkbox>
          </List.Item>
        )}
      />

      <div className="title-space-field" style={{ marginTop: 16 }}>Agregar algo extra</div>
      <Select
        showSearch
        placeholder="Buscar una presentación para agregar"
        style={{ width: '100%' }}
        filterOption={false}
        notFoundContent={searching ? <Spin size="small" /> : null}
        onSearch={searchExtras}
        value={undefined}
        onChange={addExtra}
      >
        {searchData.map(p => (
          <Option key={p.id} value={p.id}>{`${p.description} — ${symbol} ${trunc(p.price)}`}</Option>
        ))}
      </Select>

      {extras.length > 0 && (
        <List
          size="small"
          style={{ marginTop: 8 }}
          dataSource={extras}
          renderItem={extra => (
            <List.Item
              actions={[
                <Button type="link" danger key="remove" onClick={() => removeExtra(extra.presentation_id)}>Quitar</Button>,
              ]}
            >
              <span style={{ flex: 1 }}>{extra.description}</span>
              <input
                type="number"
                min="1"
                value={extra.quantity}
                onChange={e => changeExtraQuantity(extra.presentation_id, e.target.value)}
                style={{ width: 50, marginRight: 8 }}
              />
              <span>{symbol} {trunc(extra.quantity * extra.unit_price)}</span>
            </List.Item>
          )}
        />
      )}

      <Divider />
      <div style={{ textAlign: 'right', fontWeight: 700 }}>
        Total: {symbol} {trunc(total)}
      </div>
    </Modal>
  )
}

export default EditComboModal
